import React from 'react'
import { useNavigate } from 'react-router-dom'

const ErrorsPage: React.FC = () => {
  const navigate = useNavigate()

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f5f5f5',
      padding: '20px',
    }}>
      <div style={{
        textAlign: 'center',
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        maxWidth: '600px',
        width: '100%',
      }}>
        <h1 style={{ fontSize: '120px', margin: '0', color: '#1976d2', fontWeight: 'bold' }}>404</h1>
        <h2 style={{ margin: '20px 0', color: '#333' }}>Trang không tìm thấy</h2>
        <p style={{ color: '#666', marginBottom: '30px', lineHeight: '1.6' }}>
          Xin lỗi, trang bạn đang tìm kiếm không tồn tại hoặc đã bị di chuyển.
        </p>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button 
            onClick={() => navigate('/main')}
            style={{
              padding: '12px 24px',
              backgroundColor: '#1976d2',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '16px',
            }}
          >
            Về trang chủ
          </button>
          <button 
            onClick={() => window.history.back()}
            style={{
              padding: '12px 24px',
              backgroundColor: 'transparent',
              color: '#1976d2',
              border: '2px solid #1976d2',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '16px',
            }}
          >
            Quay lại
          </button>
        </div>
      </div>
    </div>
  )
}

export {ErrorsPage}
